import React from 'react';
import Typist from 'react-typist';

// const MessageTracker = ({ dataArray }) => {
//     return (
//         <>
//         {dataArray.map((item, index) => (
//             <div key={index} className={`slds-card message ${item.type}`}>
//             {item.message && <span>{item.message}</span>}
//             </div>
//         ))}
//         </>
//     );
//   };

  const MessageTracker = ({ dataArray }) => {
    console.log("DATA  ARRAY:   ", dataArray);
    return (
      <>
        {dataArray.map((item, index) => {
          if (item.colors) {
            // Render the template if it exists
            return (
              <Typist className={`slds-card message ${item.type}`} avgTypingDelay={15} cursor={{ hideWhenDone: true }}>
                    {item.message && <span>{item.message}</span>}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                        {item.colors.map((color, index) => (
                        <div key={index} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <div
                            style={{
                                width: "20px",
                                height: "20px",
                                backgroundColor: color,
                                borderRadius: "4px",
                                border: "1px solid #ccc"
                            }}
                            ></div>
                            <span>{color}</span>
                        </div>
                        ))}
                    </div>
                </Typist>
            );
          } else {
            // Render the default message if no template exists
            if(item.type === "user") {
              if(item.image) {
                return (
                  <div key={index} className={`slds-card message ${item.type}-image`}>
                    <img src={item.message} alt="Uploaded Preview" width={150} height={150} />
                  </div>
                )
              }
              else {
                return (
                  <div key={index} className={`slds-card message ${item.type}`}>
                    {item.message && <span>{item.message}</span>}
                </div>
                );
              }
            }
            else {
              return (
                <Typist className={`slds-card message ${item.type}`} avgTypingDelay={15} stdTypingDelay={10} cursor={{ hideWhenDone: true }}>
                    {item.message && <span>{item.message}</span>}
                </Typist>
              );
            }
          }
        })}
      </>
    );
  };
  
  

  export default MessageTracker;